export default {
    details: `Quickly provide an overview of the service you're offering.`,
    basePrice: `Just set a base price for your core service. You can price specific add-ons, requirements or equipments separately in the "Add-ons" section`,
    deliveryTime: `Optionally set an estimated wait time for your customers.`,
    bank: `Soco is powered by stripe to provide secure payments. Set up your bank account to receive contract payments, tips and referral credit. Services will not show up on your profile without a bank account set up.`,
    links: `Add links to your youtube, social media and other external websites/apps `
}
